import { render, staticRenderFns } from "./PriceInquiryPage.vue?vue&type=template&id=945880ea&scoped=true"
import script from "./PriceInquiryPage.vue?vue&type=script&lang=js"
export * from "./PriceInquiryPage.vue?vue&type=script&lang=js"
import style0 from "./PriceInquiryPage.vue?vue&type=style&index=0&id=945880ea&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945880ea",
  null
  
)

export default component.exports